




























































































































































































































import { defineComponent, ref, watch, computed, onMounted } from "@vue/composition-api";
import useTimerSchedule from "@/store/useTimerSchedule";
import TimerScheduleViewModel from "@/models/TimerScheduleViewModel";
import _ from "lodash";
import moment from "moment-timezone";
import { app } from "@/store";
import useUserSettings from "@/store/useUserSettings";
import ca from "date-fns/esm/locale/ca/index";

export default defineComponent({
    components: {
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConfirmDialog.vue")
    },
    props: {
        value: { type: Boolean, default: false },
        deviceType: { type: Number, default: 2 }
    },
    setup(props, context) {
        const { getUserSettings } = useUserSettings();
        const userTimezone = ref<string>("UTC");

        const { update, add, get, remove } = useTimerSchedule();
        //const timerSchedule = ref<TimerScheduleViewModel>();

        const timerSchedule = ref<TimerScheduleViewModel>({
            CORE_ID: null,
            attachedDeviceTypeId: null,
            mondayActive: false,
            tuesdayActive: false,
            wednesdayActive: false,
            thursdayActive: false,
            fridayActive: false,
            saturdayActive: false,
            sundayActive: false,
            repeatActive: false,
            enabledActive: false,
            fromTime: null,
            toTime: null,
        });

        const tempTimerSchedule = ref<TimerScheduleViewModel>({
            CORE_ID: null,
            attachedDeviceTypeId: null,
            mondayActive: false,
            tuesdayActive: false,
            wednesdayActive: false,
            thursdayActive: false,
            fridayActive: false,
            saturdayActive: false,
            sundayActive: false,
            repeatActive: false,
            enabledActive: false,
            fromTime: null,
            toTime: null,
        });

        const open = computed(() => {
            return props.value;
        });

        const close = () => {
            context.emit("input", false);
        };

        const initClose = () => {
            get(props.deviceType).then((model: TimerScheduleViewModel) => {
                tempTimerSchedule.value = model;  // save the current state
                // Check if the model has changed
                if (JSON.stringify(model) == JSON.stringify(timerSchedule.value)) {
                    console.log("No changes");
                    close();
                } else {
                    console.log("Changes");
                    showClose.value = true;
                }
            });
        };

        const closeOk = () => {
            console.log("Ok");
            timerSchedule.value = tempTimerSchedule.value;
            fromTime.value = tempTimerSchedule.value.fromTime;
            toTime.value = tempTimerSchedule.value.toTime;
            showClose.value = false;
            close();
        };

        const cancelClose = () => {
            console.log("Cancel");
            showClose.value = false;
        };

        const fromTime = ref(null);
        const toTime = ref(null);
        const fromModel = ref(false);
        const toModel = ref(false);
        const showClose = ref<boolean>(false);

        get(props.deviceType).then((model: TimerScheduleViewModel) => {
            timerSchedule.value = model;
            fromTime.value = model.fromTime;
            toTime.value = model.toTime;
        });

        const initSave = () => {
            // Convert local -> UTC before saving
            timerSchedule.value.fromTime = fromTime.value
                ? moment.tz(fromTime.value, "HH:mm", userTimezone.value).utc().format("HH:mm")
                : null;

            timerSchedule.value.toTime = toTime.value
                ? moment.tz(toTime.value, "HH:mm", userTimezone.value).utc().format("HH:mm")
                : null;

            update(timerSchedule.value).then(() => {
                app.success = "Timer schedule updated successfully.";
                close();
            });
        };

        const initRemove = () => {
            remove(props.deviceType).then(() => {
                app.success = "Timer schedule cleared successfully.";
                close();
                get(props.deviceType).then((model: TimerScheduleViewModel) => {
                    timerSchedule.value = model;
                    fromTime.value = model.fromTime;
                    toTime.value = model.toTime;
                });
            })
        };

        onMounted(async () => {
            const settings = await getUserSettings();
            userTimezone.value = settings.timezone || "UTC";

            // Load timer schedule from device (UTC times)
            const model = await get(props.deviceType);

            timerSchedule.value = model;

            // Convert UTC -> local for UI
            fromTime.value = model.fromTime
                ? moment.utc(model.fromTime, "HH:mm").tz(userTimezone.value).format("HH:mm")
                : null;

            toTime.value = model.toTime
                ? moment.utc(model.toTime, "HH:mm").tz(userTimezone.value).format("HH:mm")
                : null;
        });

        return {
            open,
            close,
            initClose,
            showClose,
            closeOk,
            cancelClose,
            initSave,
            initRemove,
            timerSchedule,
            fromTime,
            toTime,
            fromModel,
            toModel,
        };
    }
});
